export default "__VITE_ASSET__bce359e1__"